export default __webpack_public_path__ + "static/media/misc-closetC-1920w.4decd646.webp";